import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigServer } from './config-server';

/** Factory que carrega o arquivo config.json */
export function initConfigServer(configServerService: ConfigServerService) {
  return () => configServerService.load();
}

/**
 * Service que carrega a configuração da aplicação
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigServerService {
  private config: ConfigServer;

  constructor(private http: HttpClient) {}

  /**
   * Carrega a configuração usando variáveis de ambiente
   */
  load() {
    return new Promise((resolve: any, reject: any) => {
      try {
        this.config = {
          pathApi: environment.pathApi
        };
        resolve(true);
      } catch (error) {
        console.error(
          'Erro ao carregar configuração das variáveis de ambiente:',
          error
        );
        reject(false);
      }
    });
  }

  /** Configuração da aplicação */
  getConfig(): ConfigServer {
    return this.config;
  }

  /** Configuração do Server da aplicação */
  getServer(): ConfigServer {
    if (!this.config) {
      return null;
    }
    return this.config;
  }

  /** Path da API da aplicação */
  getPathApi(): string {
    const server = this.getServer();
    if (!server) {
      return null;
    }
    return server.pathApi;
  }

  /** Path da API das configurações da aplicação */
  getPathApiConfig(): string {
    return `${this.getPathApi()}/config`;
  }

  /** Path da API de Typeaheads da aplicação */
  getPathApiTypeahead(): string {
    return `${this.getPathApi()}/typeahead`;
  }

  /** Path da API de gráficos da aplicação */
  getPathApiChart(): string {
    return `${this.getPathApi()}/chart`;
  }

  /** Path da API de relatórios da aplicação */
  getPathApiPrint(): string {
    return `${this.getPathApi()}/print`;
  }

  /** Resource das APIs de impressões da Aplicação */
  getReportsAPIResource(): string {
    return `${this.getPathApi()}/reports`;
  }

  /** Resource das APIs de recursos, entidades, enums comuns da aplicação */
  getCommonAPIResource(): string {
    return `${this.getPathApi()}/common`;
  }

  /** Path da API de exportação de arquivos Excel da aplicação */
  getPathApiExcel(): string {
    return `${this.getPathApi()}/excel`;
  }

  /** Path da API de integração da aplicação */
  getPathApiIntegration(): string {
    return `${this.getPathApi()}/integration`;
  }

  /** Path da API de integração da aplicação com e-commerces */
  getPathApiIntegrationEcommerce(): string {
    return `${this.getPathApi()}/integration/ecommerce`;
  }

  /** Path da API de integração da aplicação das empresas */
  getPathApiIntegrationEmpresas(): string {
    return `${this.getPathApi()}/integration/empresa`;
  }

  /** Path da API de integração da aplicação com ERPs */
  getPathApiIntegrationErp(): string {
    return `${this.getPathApi()}/integration/erp`;
  }

  /** Path da API de envio de e-mails da aplicação */
  getPathApiEmail(): string {
    return `${this.getPathApi()}/email`;
  }

  /** Path da API dos indicadores da aplicação */
  getPathApiIndicador(): string {
    return `${this.getPathApi()}/indicador`;
  }

  /** Resource das APIs de KPIs da Aplicação */
  getKPIsAPIResource(): string {
    return `${this.getPathApi()}/kpis`;
  }

  /** Path da API das contulas da aplicação */
  getPathApiConsulta(): string {
    return `${this.getPathApi()}/consulta`;
  }

  /** Path da API dos widgets da aplicação */
  getPathApiWidgets(): string {
    return `${this.getPathApi()}/widgets`;
  }
}
